import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {

  @Input() title:string;
  @Input() link?: string = null;
  @Input() name: string;

  constructor() { }

  ngOnInit() {
  }

}
